import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-63b14f9f"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "card border-0 bg-white flex-lg-row" };
const _hoisted_2 = { class: "card-body p-4 p-lg-40px" };
const _hoisted_3 = { class: "card-title h4 mb-20px" };
const _hoisted_4 = { class: "card-text d-lg-flex gap-12px pb-12px" };
const _hoisted_5 = { class: "mb-12 mb-lg-0 d-flex gap-12px" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa-solid fa-location-dot" }, null, -1));
const _hoisted_7 = { class: "mb-0 d-flex gap-12px" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa-solid fa-phone" }, null, -1));
const _hoisted_9 = ["aria-label"];
const _hoisted_10 = ["id", "name", "value", "checked", "onChange"];
const _hoisted_11 = ["for"];
const _hoisted_12 = { class: "c-date-radios pt-20px pb-12px d-flex gap-12px" };
const _hoisted_13 = {
    key: 0,
    class: "c-date-item"
};
const _hoisted_14 = ["id", "name", "value", "disabled", "onInput"];
const _hoisted_15 = ["for"];
const _hoisted_16 = { class: "c-date-item__date d-block py-1" };
const _hoisted_17 = { class: "c-date-item__day d-block py-1" };
const _hoisted_18 = {
    key: 0,
    class: "d-flex align-items-center gap-12px"
};
const _hoisted_19 = {
    key: 1,
    class: "d-flex align-items-center"
};
const _hoisted_20 = { class: "d-flex ms-auto" };
const _hoisted_21 = /*#__PURE__*/ _createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" data-v-63b14f9f><g clip-path=\"url(#clip0_1727_5027)\" data-v-63b14f9f><path d=\"M12.4449 7.99565C12.4449 7.0138 13.2408 6.21785 14.2227 6.21785C15.2045 6.21785 16.0005 7.0138 16.0005 7.99565C16.0005 8.97749 15.2045 9.77344 14.2227 9.77344C13.2408 9.77344 12.4449 8.97749 12.4449 7.99565Z\" fill=\"#8A949A\" data-v-63b14f9f></path><path d=\"M6.22225 7.99565C6.22225 7.0138 7.01819 6.21785 8.00004 6.21785C8.98189 6.21785 9.77783 7.0138 9.77783 7.99565C9.77783 8.97749 8.98189 9.77344 8.00004 9.77344C7.01819 9.77344 6.22225 8.97749 6.22225 7.99565Z\" fill=\"#8A949A\" data-v-63b14f9f></path><path d=\"M-0.000408151 7.99565C-0.00040814 7.0138 0.795536 6.21785 1.77738 6.21785C2.75923 6.21785 3.55518 7.0138 3.55518 7.99565C3.55518 8.97749 2.75923 9.77344 1.77738 9.77344C0.795536 9.77344 -0.000408163 8.97749 -0.000408151 7.99565Z\" fill=\"#8A949A\" data-v-63b14f9f></path></g><defs data-v-63b14f9f><clipPath id=\"clip0_1727_5027\" data-v-63b14f9f><rect width=\"16\" height=\"16\" fill=\"white\" transform=\"matrix(1.19249e-08 -1 -1 -1.19249e-08 16 16)\" data-v-63b14f9f></rect></clipPath></defs></svg>", 1);
const _hoisted_22 = [
    _hoisted_21
];
const _hoisted_23 = ["id"];
const _hoisted_24 = {
    class: "pt-20px d-flex gap-12px flex-wrap",
    style: { "min-height": "65px" }
};
const _hoisted_25 = ["id", "name", "value", "disabled"];
const _hoisted_26 = ["for"];
const _hoisted_27 = {
    key: 2,
    class: "c-store-over-capacity pt-20px pb-12px"
};
const _hoisted_28 = { class: "card-link py-40px py-lg-0 px-lg-40px d-flex justify-content-center align-items-center" };
const _hoisted_29 = ["disabled"];
import { useWindowSize } from '@vueuse/core';
import flatpickr from 'flatpickr';
import { MandarinTraditional } from 'flatpickr/dist/l10n/zh-tw';
import { computed, inject, onMounted, onUnmounted, ref, watch } from 'vue';
import { $lang, dateFormat, taipeiNow } from '@vue/services/utilities';
import 'flatpickr/dist/flatpickr.min.css';
export default /*#__PURE__*/ _defineComponent({
    __name: 'StoreCard',
    props: {
        item: {},
        brands: {},
        filters: {}
    },
    emits: ['reserve'],
    async setup(__props, { emit: __emit }) {
        let __temp, __restore;
        const emits = __emit;
        const props = __props;
        const { width, height } = useWindowSize();
        const locale = inject('locale');
        const currentBrand = computed(() => {
            return props.brands.find(v => v.id === props.item.brandId);
        });
        const title = computed(() => {
            const brandTitle = locale === 'zh-TW'
                ? currentBrand.value?.tw.title
                : currentBrand.value?.en.title;
            const storeTitle = locale === 'zh-TW'
                ? props.item.tw.title
                : props.item.en.title;
            return brandTitle + ' ' + storeTitle;
        });
        const address = computed(() => {
            return locale === 'zh-TW'
                ? props.item.tw.address
                : props.item.en.address;
        });
        const dates = ref();
        const timeSlots = ref();
        const currentDate = ref();
        const currentTimeSlot = ref();
        const date = ref(props.filters.date);
        const showDateLength = ref(6);
        const searchFailed = ref(false);
        const partySize = computed(() => {
            return (props.filters.adults ?? 0) + (props.filters.children ?? 0);
        });
        // 本店設定的最大可容納人數（0 或未設定＝不限制，維持原行為）
        const storeMaxCustomer = computed(() => Number(props.item.maxCustomer) || 0);
        // 選定人數超過本店上限：不顯示「訂位已滿」，改提示本店最多可容納人數
        const overCapacity = computed(() => {
            return storeMaxCustomer.value > 0 && partySize.value > storeMaxCustomer.value;
        });
        // 座位類型（板前席／雅座席）：API loadStores 的 seatTypes 有兩種以上才讓客人選（新鐵板系把雅座併進板前店）；
        // 空陣列＝不用選，查時段與送單都不帶，後端照舊。雅座滿了不會自動改給板前，客人自己切換。
        const seatTypes = computed(() => props.item.seatTypes ?? []);
        const seatType = ref(seatTypes.value[0] ?? '');
        ;
        (([__temp, __restore] = _withAsyncContext(() => search())),
            await __temp,
            __restore());
        if (width.value >= 768) {
            showDateLength.value = 6;
        }
        else {
            showDateLength.value = 3;
        }
        onMounted(() => {
            u.on(`update.card.value.${props.item.id}`, async () => {
                await search();
            });
            initDatePicker();
        });
        onUnmounted(() => {
            u.off(`update.card.value.${props.item.id}`);
        });
        watch(() => props.filters.date, (v) => {
            if (v) {
                date.value = props.filters.date;
            }
        });
        watch(width, (newWidth, oldWidth) => {
            if (newWidth >= 768) {
                showDateLength.value = 6;
            }
            else {
                showDateLength.value = 3;
            }
        });
        async function search() {
            timeSlots.value = undefined;
            currentDate.value = undefined;
            currentTimeSlot.value = undefined;
            // 人數超過本店上限時不查詢，改由畫面提示最多可容納人數
            if (overCapacity.value) {
                dates.value = {};
                return;
            }
            let headcount = 0;
            if (props.filters.adults) {
                headcount = headcount + props.filters.adults;
            }
            if (props.filters.children) {
                headcount = headcount + props.filters.children;
            }
            // 失敗不往外丟：這支在 setup 最上層 await，一丟例外整張卡片就停在 Loading、不能重試
            // （v1.8.7.3 驗收第 4 節）。改成顯示錯誤與「重新載入」。
            try {
                const res = await u.$http.get('front/reserve/search', {
                    params: {
                        id: props.item.id,
                        date: date.value,
                        headcount: headcount,
                        ...(seatType.value ? { seatType: seatType.value } : {}),
                    }
                });
                dates.value = res.data.data;
                searchFailed.value = false;
            }
            catch (e) {
                dates.value = {};
                searchFailed.value = true;
            }
        }
        async function reserve() {
            emits('reserve', {
                brandId: props.item.brandId,
                storeId: props.item.id,
                date: currentDate.value,
                time: currentTimeSlot.value,
                // 一律帶（沒有類型＝空字串）：MainStore 會沿用上一次的鍵，不帶會殘留前一家店選的類型
                seatType: seatType.value,
            });
        }
        async function changeSeatType(v) {
            if (seatType.value === v) {
                return;
            }
            seatType.value = v;
            await search();
        }
        async function updateDate(v) {
            const target = v.target;
            date.value = target.value;
            await search();
        }
        async function setTimeSlots(slots) {
            if (isDateDisabled(slots)) {
                return;
            }
            currentTimeSlot.value = undefined;
            const slotEntries = Object.entries(slots);
            timeSlots.value = Object.fromEntries(slotEntries.sort((a, b) => {
                const timeA = a[0].split(':').map(Number);
                const timeB = b[0].split(':').map(Number);
                const dateA = new Date().setHours(timeA[0], timeA[1], 0, 0);
                const dateB = new Date().setHours(timeB[0], timeB[1], 0, 0);
                return dateA - dateB;
            }));
        }
        function showDate(idx) {
            const keys = Object.keys(dates.value);
            return keys.indexOf(idx) <= showDateLength.value;
        }
        function getDateOfWeek(date) {
            const format = dateFormat(date, 'ddd');
            if (locale === 'zh-TW') {
                switch (format) {
                    case 'Mon':
                        return '週一';
                    case 'Tue':
                        return '週二';
                    case 'Wed':
                        return '週三';
                    case 'Thu':
                        return '週四';
                    case 'Fri':
                        return '週五';
                    case 'Sat':
                        return '週六';
                    case 'Sun':
                        return '週日';
                }
            }
            return format;
        }
        function isDateDisabled(timeSlots) {
            return Object.values(timeSlots).filter(v => v).length === 0;
        }
        function getInputId(prefix, idx) {
            return `store-${props.item.id}-input-${prefix}-${idx}`;
        }
        const picker = ref();
        function initDatePicker() {
            // 日曆 minDate/maxDate 以台灣日期為準（國外裝置今天可能與台灣差一天，避免可選日整體偏移一天）
            const today = taipeiNow();
            const minDate = today.format('YYYY-MM-DD');
            const maxDate = today.add(props.item.maxReserveLimit, 'day').format('YYYY-MM-DD');
            picker.value = flatpickr(`#` + getInputId('date', 'picker'), {
                ...(locale === 'zh-TW' ? { locale: MandarinTraditional } : {}),
                minDate,
                maxDate,
                position: 'auto right',
            });
        }
        function togglePicker() {
            picker.value?.open();
        }
        const disabledReserveBtn = computed(() => {
            if (overCapacity.value) {
                return true;
            }
            if (Object.keys(dates.value).length <= 0) {
                return true;
            }
            if (!currentTimeSlot.value) {
                return true;
            }
            return false;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h2", _hoisted_3, _toDisplayString(title.value), 1),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("p", _hoisted_5, [
                            _hoisted_6,
                            _createTextVNode(" " + _toDisplayString(address.value), 1)
                        ]),
                        _createElementVNode("p", _hoisted_7, [
                            _hoisted_8,
                            _createTextVNode(" " + _toDisplayString(_ctx.item.phone), 1)
                        ])
                    ]),
                    (seatTypes.value.length > 1)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "c-seat-type pt-12px d-flex gap-12px flex-wrap",
                            role: "radiogroup",
                            "aria-label": _unref($lang)('app.reservation.seat.type.label')
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seatTypes.value, (type) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: _ctx.item.id + '-seat-' + type,
                                    class: "c-time-item"
                                }, [
                                    _createElementVNode("input", {
                                        type: "radio",
                                        class: "btn-check",
                                        id: getInputId('seat', type),
                                        autocomplete: "off",
                                        name: `store-` + _ctx.item.id + `-seat-type`,
                                        value: type,
                                        checked: seatType.value === type,
                                        onChange: ($event) => (changeSeatType(type))
                                    }, null, 40, _hoisted_10),
                                    _createElementVNode("label", {
                                        for: getInputId('seat', type),
                                        class: "btn btn-sm btn-outline-primary"
                                    }, _toDisplayString(_unref($lang)('app.reservation.seat.type.' + type)), 9, _hoisted_11)
                                ]));
                            }), 128))
                        ], 8, _hoisted_9))
                        : _createCommentVNode("", true),
                    (!overCapacity.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_12, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dates.value, (date, idx) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                        (showDate(idx))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "radio",
                                                    class: "btn-check",
                                                    id: getInputId('date', idx),
                                                    autocomplete: "off",
                                                    name: `store-` + _ctx.item.id + `-date`,
                                                    value: idx,
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((currentDate).value = $event)),
                                                    disabled: isDateDisabled(date),
                                                    onInput: ($event) => (setTimeSlots(date))
                                                }, null, 40, _hoisted_14), [
                                                    [_vModelRadio, currentDate.value]
                                                ]),
                                                _createElementVNode("label", {
                                                    for: getInputId('date', idx),
                                                    class: "w-100 text-center"
                                                }, [
                                                    _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(dateFormat)(idx, 'MM-DD')), 1),
                                                    _createElementVNode("span", _hoisted_17, [
                                                        (isDateDisabled(date))
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                _createTextVNode(_toDisplayString(_unref($lang)('app.reservations.no.available')), 1)
                                                            ], 64))
                                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                _createTextVNode(_toDisplayString(getDateOfWeek(idx)), 1)
                                                            ], 64))
                                                    ])
                                                ], 8, _hoisted_15)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ], 64));
                                }), 256)),
                                (Object.keys(dates.value).length <= 0)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (searchFailed.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                _createElementVNode("div", null, _toDisplayString(_unref($lang)('app.reservation.load.failed')), 1),
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "btn btn-sm btn-outline-primary text-nowrap",
                                                    onClick: search
                                                }, _toDisplayString(_unref($lang)('app.reservation.load.retry')), 1)
                                            ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                _createElementVNode("div", null, _toDisplayString(_unref($lang)('app.reservations.available.day.text', '0 ~ ' + _ctx.item.maxReserveLimit)), 1)
                                            ]))
                                    ], 64))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "c-card-flatpickr-btn btn h-100",
                                        onClick: togglePicker
                                    }, _hoisted_22),
                                    _createElementVNode("input", {
                                        id: getInputId('date', 'picker'),
                                        type: "text",
                                        class: "c-card-flatpickr h-100 form-control",
                                        onInput: updateDate
                                    }, null, 40, _hoisted_23)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeSlots.value, (disabled, idx) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        class: "c-time-item",
                                        key: _ctx.item.id + '-' + currentDate.value + '-' + idx
                                    }, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "radio",
                                            class: "btn-check",
                                            id: getInputId(currentDate.value, idx),
                                            autocomplete: "off",
                                            name: `store-` + _ctx.item.id + `-slot`,
                                            value: idx,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((currentTimeSlot).value = $event)),
                                            disabled: !disabled
                                        }, null, 8, _hoisted_25), [
                                            [_vModelRadio, currentTimeSlot.value]
                                        ]),
                                        _createElementVNode("label", {
                                            for: getInputId(currentDate.value, idx),
                                            class: "btn btn-sm btn-outline-primary"
                                        }, _toDisplayString(idx), 9, _hoisted_26)
                                    ]));
                                }), 128))
                            ])
                        ], 64))
                        : (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_unref($lang)('app.reservations.over.capacity', storeMaxCustomer.value)), 1))
                ]),
                _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("button", {
                        type: "button",
                        class: "btn c-btn-customization-primary",
                        disabled: disabledReserveBtn.value,
                        onClick: reserve
                    }, [
                        _createElementVNode("span", null, _toDisplayString(_unref($lang)('app.reservation.btn.reserve')), 1)
                    ], 8, _hoisted_29)
                ])
            ]));
        };
    }
});
